module.exports = __webpack_public_path__ + "src/assets/img/meeting_restaurant1.ffefbf9b.jpg";